import { doInitLocationDetailed } from "./location"
import { initMap } from "./map"

(window as any).initWeatherMap = async () => {
    initMap()
}

(window as any).initLocationDetailed = async (id: number) => {
    doInitLocationDetailed(id)
}
